var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submit-button',{attrs:{"working":_vm.working,"left-icon":"check-circle","type":"far"},on:{"submit":_vm.submit}},[_vm._v(" Save ")])}
var staticRenderFns = []

export { render, staticRenderFns }